import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, Image, Input, useClipboard } from '@chakra-ui/react';
import { FaFacebook, FaTelegram, FaWhatsapp } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import LeaderBoard from '../../components/LeaderBoard';
import Confetti from 'react-confetti';
import useCurrentWindowWidth from '../../hook/useWindowWidth';
import useQuery from '../../hook/useQuery';
import { useHistory } from 'react-router-dom';
import womanImg from '../../img/woman-img-big.svg';
import style from './style.module.css';
import Logo from '../../components/logo';
import Flip from 'react-reveal/Flip';
import { Text } from '@chakra-ui/layout'
import { Link } from "@chakra-ui/react"

function InvitationPage() {
  const [value, setValue] = React.useState('');
  const { hasCopied, onCopy } = useClipboard(value);
  const { width, height } = useCurrentWindowWidth();
  const query = useQuery();
  const history = useHistory();
  const [confettiHasFinished, setconfettiHasFinished] = useState(false);

  useEffect(() => {
    if(query.get('code')){
      let referralCode = query.get('code');
      setValue(`${window.location.origin}?code=${referralCode}`);
    }else{
      history.push('/');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.get('code')]);

  return (
    <Box overflowX="hidden" height="100vh" display="flex">
      <Helmet>
        <title>Swift Finance || Invite </title>
      </Helmet>

      <Box
      className={style.invitation_sidepanel}
      width="100%"
      background="radial-gradient(circle, rgb(104, 56, 219) 0%, rgb(56, 30, 119) 100%, rgb(54, 29, 114) 100%)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
        <Logo style={{
                position: "absolute",
                top: "18px",
                width: "190px",
                left: "19px"
        }}/>

      <Image position="absolute" bottom="0" src={womanImg} alt="swift bank logo" />
    </Box>


      <Confetti
        style={{display: confettiHasFinished ? 'none': ''}}
        recycle={false}
        numberOfPieces="500"
        width={width}
        height={height}
        onConfettiComplete={()=>{
          setconfettiHasFinished(true)
        }}
      />

      <Box
        className={style.invitation_content}
        width="2500px"
        padding="18px"
        display="flex"
        flexDirection="column"
      >
        <h1
          style={{
            textAlign: 'center',
            marginBottom: '10px',
            fontSize: '25px',
            fontWeight: 'bolder',
          }}
        >
          Congratulations 🎉🎉
        </h1>

        <p>
          Thanks for joining our waitlist, we will be granting app access to everyone that has registered on a rolling basis. &nbsp;
          <b>Want to access even sooner?</b>
        </p>
        <p>
          Move up 10 spots for every person that joins our waitlist using your
          referal link below and also stand a chance to win awesome prizes if you are
          among our top 10 referrals.
        </p>

        <Box
          height="300px"
          justifyContent="space-between"
          display="flex"
          flexDirection="column"
        >
          <Flex margin="20px 0" mb={2}>
            <Input value={value} isReadOnly placeholder="Welcome" />
            <Button
              backgroundColor="#5c32c1"
              color="white"
              fontSize="12px"
              onClick={onCopy}
              _hover={{
                  backgroundColor: "#5a30bd"
              }}
              _active={{
                  backgroundColor: "#391f7a"
              }}
              ml={2}
            >
              {hasCopied ? 'Copied' : 'COPY LINK'}
            </Button>
          </Flex>

          {/* Join our community */}
          <Flip cascade left>
                    <Text textAlign="center" mt="50px" mb="10px" p="0 5px" fontSize="25px" fontWeight="600" bgGradient="linear(to-l, rgba(104,56,219,1), rgba(54,29,114,1),#FF0080)" bgClip="text" as="h1" padding="0px 20px"> Join other business owners in our SME communities </Text>
          </Flip>

          <p className={style.comm_text}>We are building a community of business owners all around the Nation and we want you to be a part of it; we get to share marketing tips with one another, share opportunities, promote one another's businesses, form strategic partnerships and lots more. You can click on any of the buttons below to join any of our active communties accross all the 3 social media platforms. See you there!</p>

          <Box
            alignContent="space-between"
            display="flex"
            flexDirection="column"
          >

<Link href="https://www.facebook.com/groups/467148004945397/" className={style.link}>
            <Button
              transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
              color="white"
              _active={{
                transform: 'scale(0.98)',
              }}
              margin="10px 0"
              colorScheme="facebook"
              leftIcon={<FaFacebook size={20}/>}
              width="100%"
            >
              Join on Facebook
            </Button>
</Link>


<Link href="https://chat.whatsapp.com/FckJhIrPFDt99VJEUG9Qy4" className={style.link}> 
            <Button
              transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
              color="white"
              _active={{
                transform: 'scale(0.98)',
              }}
              margin="10px 0"
              colorScheme="whatsapp"
              leftIcon={<FaWhatsapp size={20}/>}
              width="100%"
            >
              Join on WhatsApp
            </Button>
</Link>


<Link href="https://t.me/+wNeNbiiOR4MwYjQ0" className={style.link}>
            <Button
              _hover={{ color: 'white' }}
              transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
              color="white"
              _active={{
                transform: 'scale(0.98)',
              }}
              margin="10px 0"
              // background="linear-gradient(to right, #F58529, #FEDA77, #DD2A7B, #8134AF, #515BD4)"
              colorScheme="telegram"
              leftIcon={<FaTelegram size={20} />}
              width="100%"
            >
              Join on Telegram
            </Button>
</Link>
          </Box>

          <LeaderBoard />
        </Box>
      </Box>
    </Box>
  );
}

export default InvitationPage;